import Vue from 'vue'
import Vuex from 'vuex'
// Modules 
import SecurityModule from '@/store/modules/Security'
import InfoModule from '@/store/modules/Info'
import ActionModule from '@/store/modules/Action'
import ProfileModule from '@/store/modules/Profile'
import ModalModule from '@/store/modules/Modal'
import NotificationModule from '@/store/modules/Notification'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    SecurityModule,
    InfoModule,
    ActionModule,
    ProfileModule,
    ModalModule,
    NotificationModule
  }
})
